import { render } from "./AssignUsers.vue?vue&type=template&id=e264075e&scoped=true"
import script from "./AssignUsers.vue?vue&type=script&lang=js"
export * from "./AssignUsers.vue?vue&type=script&lang=js"

import "./AssignUsers.vue?vue&type=style&index=0&id=e264075e&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e264075e"]])

export default __exports__